import { Action, ACTION_TYPE } from '@abiglobalhealth/go-types'

import { actionsRequest } from './utils'

export const setPharmacyChoice = async <T extends Action<ACTION_TYPE.SET_PHARMACY_CHOICE>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.SET_PHARMACY_CHOICE
  })

  if (!body?.data) throw new Error('No data')

  return body.data
}

export const setFulfillmentCollect = async <T extends Action<ACTION_TYPE.SET_FULFILLMENT_COLLECT>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.SET_FULFILLMENT_COLLECT
  })

  return body.data
}

export const getPharmacies = async <T extends Action<ACTION_TYPE.GET_PHARMACIES>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.GET_PHARMACIES
  })

  if (!body?.data) throw new Error('No data')

  return body.data
}
